import React, { useState, useEffect } from "react";
import * as styles from "./ExpertsList.module.scss";
import Image from "../../../UI/Image";
import { useIntl } from "gatsby-plugin-intl";

interface Expert {
	img: string;
	name: string;
	jobTitle: string;
	text: string;
}

const expertList: Expert[] = [
	{ img: "/images/leadership/minakov.jpg", name: "about.leadership.card-1.name", jobTitle: "about.leadership.card-1.post", text: "about.leadership.card-1.description" },
	{ img: "/images/leadership/tagaeva.png", name: "about.leadership.card-2.name", jobTitle: "about.leadership.card-2.post", text: "about.leadership.card-2.description" },
	{ img: "/images/leadership/borisova.png", name: "about.leadership.card-3.name", jobTitle: "about.leadership.card-3.post", text: "about.leadership.card-3.description" },
	{ img: "/images/leadership/yolkin.jpg", name: "about.leadership.card-4.name", jobTitle: "about.leadership.card-4.post", text: "about.leadership.card-4.description" },
	{ img: "/images/leadership/kada.jpg", name: "about.leadership.card-5.name", jobTitle: "about.leadership.card-5.post", text: "about.leadership.card-5.description" },
	{ img: "/images/leadership/abdulaliev.jpg", name: "about.leadership.card-6.name", jobTitle: "about.leadership.card-6.post", text: "about.leadership.card-6.description" },
];

const ExpertsList: React.FC = () => {
	const [selected, setSelected] = useState<Expert | null>(null);
	const intl = useIntl();

	// Закрытие модалки по Esc и блокировка фонового скролла
	useEffect(() => {
		if (!selected) return;

		const scrollY = window.scrollY;

		// Блокировка скролла body
		document.body.style.position = "fixed";
		document.body.style.top = `-${scrollY}px`;
		document.body.style.width = "100%";

		const handleKey = (e: KeyboardEvent) => {
			if (e.key === "Escape") closeModal();
		};

		window.addEventListener("keydown", handleKey);
		return () => {
			window.removeEventListener("keydown", handleKey);
			document.body.style.position = "";
			document.body.style.top = "";
			window.scrollTo(0, scrollY);
		};
	}, [selected]);

	const closeModal = () => setSelected(null);

	return (
		<div className={styles.experts}>
			<ul className={styles.expertsList}>
				{expertList.map((item, index) => (
					<li
						key={index}
						className={styles.card}
						onClick={() => setSelected(item)}
						tabIndex={0}
						role="button"
						onKeyDown={(e) => {
							if (e.key === "Enter" || e.key === " ") setSelected(item);
						}}
					>
						<Image className={styles.img} src={item.img} alt={item.name} width={384} />
						<h3>{intl.formatMessage({ id: item.name })}</h3>
						<p><span>{intl.formatMessage({ id: item.jobTitle })}</span></p>
					</li>
				))}
			</ul>

			{selected && (
				<div className={styles.modalOverlay} onClick={closeModal}>
					<div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
						<button className={styles.closeBtn} onClick={closeModal}>
							<picture>
								{/* Мобильный логотип */}
								<source
									srcSet="/icons/close-icon-white.svg"
									media="(max-width: 475px)"
									type="image/svg+xml"
								/>

								{/* Десктопный логотип через Next.js Image */}
								<img
									className="object-contain"
									src="/icons/close-icon.svg"
									alt="close"
									sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
								/>
							</picture>

						</button>
						<div className={styles.modalLeft}>
							<div className={styles.imgBlock}>
								<Image className={styles.img} src={selected.img} alt={selected.name} width={384} noLazy />
							</div>
							<h3>{intl.formatMessage({ id: selected.name })}</h3>
							<p><span>{intl.formatMessage({ id: selected.jobTitle })}</span></p>
						</div>
						<div className={styles.modalRight}>
							<p>{intl.formatMessage({ id: selected.text })}</p>
						</div>
					</div>
				</div>
			)}
		</div>
	);
};

export default ExpertsList;
